import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import '../Customers/Customers.css';

function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const response = await adminAPI.getDashboardStats();
      setStats(response.stats);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load dashboard statistics');
      console.error('Error loading stats:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-main-wrapper">
          <main className="dashboard-content">
            <div className="customer-list-container">
              <div className="loading">Loading dashboard...</div>
            </div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-main-wrapper">
        <main className="dashboard-content">
          <div className="customer-list-container">
            <div className="customer-list-header">
              <h1>Administration Dashboard</h1>
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            {stats && (
              <div className="module-grid">
                <div className="module-card stat-card stat-card-primary">
                  <div className="module-icon icon-gradient">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="url(#purpleGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                  </div>
                  <div className="stat-content">
                    <div className="stat-value">{stats.total_users}</div>
                    <div className="stat-label">Total Users</div>
                  </div>
                </div>
                <div className="module-card stat-card stat-card-success">
                  <div className="module-icon icon-gradient">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="url(#purpleGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <div className="stat-content">
                    <div className="stat-value">{stats.active_users}</div>
                    <div className="stat-label">Active Users</div>
                  </div>
                </div>
                <div className="module-card stat-card stat-card-warning">
                  <div className="module-icon icon-gradient">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="url(#purpleGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                  </div>
                  <div className="stat-content">
                    <div className="stat-value">{stats.administrators}</div>
                    <div className="stat-label">Administrators</div>
                  </div>
                </div>
                <div className="module-card stat-card stat-card-info">
                  <div className="module-icon icon-gradient">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="url(#purpleGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
                  </div>
                  <div className="stat-content">
                    <div className="stat-value">{stats.verified_devices}</div>
                    <div className="stat-label">Verified Devices</div>
                  </div>
                </div>
              </div>
            )}
            <svg width="0" height="0">
              <defs>
                <linearGradient id="purpleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#667eea" />
                  <stop offset="100%" stopColor="#764ba2" />
                </linearGradient>
              </defs>
            </svg>

            <div className="info-box">
              <h3>Quick Actions</h3>
              <p>Use the navigation menu to access user management and other administrative functions.</p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default AdminDashboard;
